import { Component, inject } from '@angular/core';
import {
  NotificationService,
  Notification,
} from '../../../core/services/notification.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  template: `
    <div class="fixed bottom-4 right-4 z-[9998] flex flex-col gap-2 w-80">
      @for (n of notificationService.notifications(); track n.id) {
        <div
          class="rounded-lg shadow-lg p-4 border-l-4 bg-white animate-slide-in"
          [class.border-l-maersk-info]="n.type === 'info'"
          [class.border-l-maersk-success]="n.type === 'success'"
          [class.border-l-maersk-warning]="n.type === 'warn'"
          [class.border-l-maersk-error]="n.type === 'error'">
          <div class="flex justify-between items-start">
            <div>
              <div class="font-semibold text-sm text-maersk-900">{{ n.title }}</div>
              <div class="text-xs text-maersk-900/70 mt-1">{{ n.message }}</div>
            </div>
            <button
              class="text-maersk-900/40 hover:text-maersk-900 ml-2"
              (click)="notificationService.dismiss(n.id)">
              <i class="fas fa-times text-xs"></i>
            </button>
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      @keyframes slide-in {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      .animate-slide-in {
        animation: slide-in 0.3s ease-out;
      }
    `,
  ],
})
export class NotificationsComponent {
  readonly notificationService = inject(NotificationService);
}
